module.exports = __webpack_public_path__ + "static/media/banff-37.54f0e028.jpg";